import React from "react";
import { Award } from "lucide-react";

/**
 * Renders a small donor-tier chip. `tier` is the object from the backend:
 *   { slug, label, min, color }
 * Returns null if no tier (donor below $1 or anonymous).
 */
const TierBadge = ({ tier, size = "sm", className = "" }) => {
    if (!tier) return null;
    const dims = size === "lg"
        ? { box: "px-3 py-1.5 text-sm", icon: "w-3.5 h-3.5" }
        : { box: "px-2 py-0.5 text-[11px]", icon: "w-3 h-3" };
    return (
        <span
            data-testid={`tier-badge-${tier.slug}`}
            className={`inline-flex items-center gap-1 rounded-full font-medium tracking-wide uppercase ${dims.box} ${className}`}
            style={{ backgroundColor: `${tier.color}1A`, color: tier.color, border: `1px solid ${tier.color}33` }}
            title={`Lifetime giving · ${tier.label}`}
        >
            <Award className={dims.icon} strokeWidth={2} />
            {tier.label}
        </span>
    );
};

export default TierBadge;
